import AboutSection from "../components/sections/AboutSection";
import ProgressTrackerSection from "../components/sections/ProgressTrackerSection";
import TrustSectiion from "../components/sections/TrustSectiion";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import CommitmentSection from "../components/sections/CommitmentSection";
import useAppData from "../hooks/useAppData";

const About = () => {
	const { aboutPage } = useAppData();
	return (
		<>
			<title>{aboutPage.meta_title}</title>
			<meta name="description" content={aboutPage.meta_description} />
			<meta name="keywords" content={aboutPage.meta_keywords} />
			<div>
				{/* 1. The Hero Container */}
				<div className="relative w-full h-100 overflow-hidden">
					{/* The Fixed Background Wrapper */}
					<div className="fixed inset-0 w-full h-100 z-0">
						<img
							src="/assets/images/banners/about-us-banner.jpg"
							alt="About Us Banner"
							className="w-full h-full object-cover"
						/>
						{/* Gradient Overlay stays fixed with the image */}
						<div className="absolute inset-0 bg-linear-to-t from-black/80 to-black/40"></div>
					</div>

					{/* Welcome Text - Absolute so it scrolls away with the container */}
					<div className="absolute inset-0 z-10 flex items-center justify-center text-center px-4">
						<h3 className="text-white text-2xl md:text-3xl uppercase Ethnocentric tracking-widest leading-tight">
							Welcome to <br /> Bluedart Express Dubai
						</h3>
					</div>
				</div>
				<div className="relative z-10 -mt-10 bg-white rounded-t-[40px] pt-10 shadow-[0_-10px_40px_rgba(0,0,0,0.1)]">
					<AboutSection />
					<hr className="h-px bg-linear-to-r from-transparent via-gray-300 to-transparent border-0" />
					<WhyChooseUs />
					<hr className="h-px bg-linear-to-r from-transparent via-gray-300 to-transparent border-0" />
					<ProgressTrackerSection />
					<CommitmentSection />
				</div>
				{/* Trust Section - Don't move it up! - it has fixed modal & can't be inside relative z-10 */}
				<TrustSectiion />
			</div>
		</>
	);
};

export default About;
